import React from 'react';
import { healthCalculators_En } from '../ConstantsEN';
import SharedHelmet from '../Helmet';
const TITLE = 'Free Calculators for Health and Physical Fitness - Discover Them Now';
const DESCRIPTION = 'Explore our selected collection of health and fitness calculators, such as the BMI calculator, daily calorie calculator, basic metabolic rate (BMR), and more.';
const KEYWORDS = 'BMI calculator, calorie calculator, BMR, ideal weight, body fat percentage, carbohydrates, nutritional energy units';
const NOTE = 'If you know of or wish to add other health calculators, please contact us via email at info@do-calculate.com. We will be happy to add them!';
const OG_URL = 'https://do-calculate.com/en/health-calculators';
function CalculatorsList() {
    return (
        <div className="container ltr-container">
            <SharedHelmet TITLE={TITLE} DESCRIPTION={DESCRIPTION} KEYWORDS={KEYWORDS} OG_URL={OG_URL}  />
            <div  >
                <h1 style={{ fontSize: '26px' }}>{TITLE}</h1>
                <hr />
                <div className="alert alert-info" role="alert">
                    <u><p>If you know of or wish to add other health calculators, please contact us via email at <b>info@do-calculate.com</b>. We will be happy to add them! :)</p></u>
                </div>
            </div>
            <hr/>
            <table >
                <thead>
                    <tr >
                        <th >Calculator</th>
                        <th >Description</th>
                    </tr>
                </thead>
                <tbody>
                    {healthCalculators_En.map((calculator, index) => (
                        <tr key={index}>
                            <td>
                                <a href={calculator.link}> <h2 style={{ fontSize: '14px' }}>{calculator.name}</h2> </a>
                            </td>
                            <td><p>{calculator.description}</p></td>
                        </tr>
                    ))}
                </tbody>
            </table>
            <br />
        </div>
    );
}
export default CalculatorsList;
